angular.module('impactx.autoComplete').controller('AsyncAutocompleteCtrl', [
    '$scope',
    'TranslationService',
    'dataGen',
    AsyncAutocompleteCtrl
]);

function AsyncAutocompleteCtrl($scope, TranslationService, dataGen) {
    $scope.searchText = '';
    $scope.entries = [];
    $scope.searchResults = 100;
    $scope.noSelectedItemMessage = TranslationService.get("noSelectedItemMessage");
    $scope.minLengthAsyncInput = TranslationService.get("minLengthAsyncInput");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.isReadOnlyLabel = TranslationService.get("isReadOnly");
    var idForHeader = -2;
    var idForFilterMore = -3;
    if ($scope.minLength === undefined) {
        $scope.minLength = 2;
    }
    var self = this;

    self.getItemText = function (entry) {
        if (entry && entry.value) {
            if ($scope.modifyItemText) {
                return $scope.modifyItemText({entry: entry});
            }
            else {
                return entry.value;
            }
        }
        else {
            $scope.searchText = '';
            return '';
        }
    };

    this.getEntries = function (additionalDataArray, selectIfOne) {
        var dataObject = {searchText: $scope.searchText};
        if ($scope.hiddenId) {
            dataObject.hiddenId = $scope.hiddenId;
        }
        if (additionalDataArray || $scope.additionalDataArray) {
            var additionalDataArrayToUse = additionalDataArray ? additionalDataArray : $scope.additionalDataArray;
            var i = 0;
            while (i < additionalDataArrayToUse.length) {
                if (additionalDataArrayToUse[i].value) {
                    dataObject[additionalDataArrayToUse[i].field] = additionalDataArrayToUse[i].value;
                }
                else if (additionalDataArrayToUse[i].valueFunction) {
                    dataObject[additionalDataArrayToUse[i].field] = additionalDataArrayToUse[i].valueFunction();
                }
                i++;
            }
        }
        if ($scope.entryPoint) {
            if ($scope.usePost) {
                return dataGen.postAsForm({}, dataObject, $scope.entryPoint, null, true).then(function (data) {
                    return self.extractData(data, selectIfOne);
                });
            }
            else {
                return dataGen.getData({}, dataObject, $scope.entryPoint, null, true).then(function (data) {
                    if (!data.data) {
                        return [];
                    }
                    return self.extractData(data, selectIfOne);
                });
            }

        }
        else {
            return $scope.getEntriesFunc(dataObject).then(function (data) {
                var results, hasMoreResults;
                if (Array.isArray(data)) {
                    results = data.slice(0, $scope.searchResults);
                    hasMoreResults = data.length > $scope.searchResults;
                }
                else {
                    //not only array given.
                    results = data.entries.slice(0, $scope.searchResults);
                    hasMoreResults = data.hasMoreResults || data.entries.length > $scope.searchResults;
                }
                if (hasMoreResults) {
                    data.push({id: idForFilterMore, value: TranslationService.get("hasMoreResults")});
                }
                return results;
            });
        }
    };

    this.extractData = function (data, selectIfOne) {
        var results = [];
        if (data.data.hasTwoLists && data.data.header) {
            results.push({id: idForHeader, value: data.data.header});
        }
        results = results.concat(data.data.entries.slice(0, $scope.searchResults));
        if (data.data.hasMoreResults || data.data.entries.length > $scope.searchResults) {
            results.push({id: idForFilterMore, value: TranslationService.get("hasMoreResults")});
        }
        if (data.data.hasTwoLists && data.data.additionalHeader && data.data.additionalEntries) {
            results.push({id: idForHeader, value: data.data.additionalHeader});
        }
        if (data.data.additionalEntries) {
            results = results.concat(data.data.additionalEntries.slice(0, $scope.searchResults));
            if (data.data.hasMoreResults || data.data.additionalEntries.length > $scope.searchResults) {
                results.push({id: idForFilterMore, value: TranslationService.get("hasMoreResults")});
            }
        }
        handleOneResult(results, selectIfOne);
        return results;
    };

    function handleOneResult(results, selectIfOne) {
        if (selectIfOne) {
            if (results.length == 1) {
                $scope.$applyAsync(function () {
                    $scope.selected = results[0];
                    inputBlur();
                });
            }
        }
    }

    function inputBlur() {
        var focusedElement = document.activeElement;

        if (focusedElement) {
            focusedElement.blur();
        }
    }

    if ($scope.getEntriesControl) {
        $scope.getEntriesControl.getEntries = self.getEntries;
    }

    if ($scope.showMust || $scope.selectIfOne) {
        self.getEntries(null, true);
    }

    $scope.notSelectReadOnly = function (event, selected) {
        if ($scope.cannotSelectReadOnlyItems)
        {
            if(selected && (selected.readOnly || selected.isGroupHeader || selected.id < 0)) {
                event.stopPropagation();
                $scope.$applyAsync(function () {
                    $scope.dialogData[$scope.name].$setValidity('isReadOnly', false);
                    $scope.selected = null;
                    inputBlur();
                });
            }
            else {
                $scope.dialogData[$scope.name].$setValidity('isReadOnly', true);
            }
        }
    };

}
